import { Injectable } from "@angular/core";
import { ID } from "@common/interfaces/id";
import { IID_OL_COMMUNICATION } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolCommunicationState, IIDolCommunicationStore } from "./iidOlCommunication.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_COMMUNICATION)
export class IIDolCommunicationQuery extends AbstractInterfaceDataQuery<IID_OL_COMMUNICATION> {
  constructor(protected store: IIDolCommunicationStore) {
    super(store);
  }

  selectByProjectId$(id: ID) {
    return this.selectAll({
      filterBy: [
        entity => entity.projectId === id,
        entity => !entity.deletedAt,
      ]
    });
  }

}
